module.exports = Object.freeze({
  NOT_FOUND: Object.freeze({ $type: 'notFound' }),
  PENDING: Object.freeze({ $type: 'pending' }),
  INVALIDATE: Object.freeze({ $type: 'invalidate' }),
});
